import { combineReducers, Reducer } from 'redux';
import { ApplicationState } from './ApplicationState';
import { persistReducer } from 'redux-persist';
import autoMergeLevel2 from 'redux-persist/es/stateReconciler/autoMergeLevel2';
import { PersistConfig } from 'redux-persist/es/types';
import storage from 'redux-persist/lib/storage';
import { commonReducer } from './common/reducer';
import { usersReducer, usersReducerConfig } from './users/reducer';
import { licencesReducer, licencesReducerConfig } from './licences/reducer';
import { modulesReducer } from './modules/reducer';
import { versionsReducer, versionsReducerConfig } from './versions/reducer';
import { rolesReducer } from './roles/reducer';
import { clientsReducer, clientsReducerConfig } from './clients/reducer';
import { distributorsReducer } from './distributors/reducer';
import { licenseTermsReducer } from './licenseTerms/reducer';

const reducers = {
    common: commonReducer,
    users: persistReducer(usersReducerConfig, usersReducer),
    licences: persistReducer(licencesReducerConfig, licencesReducer),
    modules: modulesReducer,
    versions: persistReducer(versionsReducerConfig, versionsReducer),
    roles: rolesReducer,
    clients: persistReducer(clientsReducerConfig, clientsReducer),
    distributors: distributorsReducer,
    licenseTerms: licenseTermsReducer,
};

const combinedReducers = combineReducers<typeof reducers>(reducers);

const globalReducer: Reducer<ApplicationState> = (state, action) => {
    return combinedReducers(state, action);
};

const persistConfig: PersistConfig<ApplicationState> = {
    key: 'root',
    storage: storage,
    stateReconciler: autoMergeLevel2,
    whitelist: [],
    blacklist: [],
};

export const persistedReducer = persistReducer(persistConfig, globalReducer);
